import { render, staticRenderFns } from "./DebtorAdjustmentGstInvoice.vue?vue&type=template&id=3412610a"
import script from "./DebtorAdjustmentGstInvoice.vue?vue&type=script&lang=js"
export * from "./DebtorAdjustmentGstInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3412610a')) {
      api.createRecord('3412610a', component.options)
    } else {
      api.reload('3412610a', component.options)
    }
    module.hot.accept("./DebtorAdjustmentGstInvoice.vue?vue&type=template&id=3412610a", function () {
      api.rerender('3412610a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/debtoradjustment/DebtorAdjustmentGstInvoice.vue"
export default component.exports